'use client';
import cn from 'classnames';
import { useEffect, useRef } from 'react';

import './HowItWorksPicker.style.scss';

import PlanCardList from '@/components/common/PlanCardList/PlanCardList';
import PriveeAddOn from '@/components/common/PriveeAddOn/PriveeAddOn';
import Text from '@/components/common/Text/Text';
import { SubscriptionProduct } from '@/types/Subscription';

type HowItWorksPickerProps = {
  className?: string;
  subscriptions: SubscriptionProduct[];
};

function HowItWorksPicker(props: HowItWorksPickerProps) {
  const { className = '', subscriptions } = props;
  const rootRef = useRef<HTMLDivElement | null>(null);

  // Position carousel to right because we want to show new Classique+ plan
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const el = root.querySelector('.PlanCarousel') as HTMLDivElement | null;
    if (!el) return;

    const positionRightAndShow = () => {
      const maxLeft = el.scrollWidth - el.clientWidth;
      if (maxLeft > 0) el.scrollLeft = maxLeft;
      el.style.visibility = 'visible';
    };

    requestAnimationFrame(() => requestAnimationFrame(positionRightAndShow));
    const onResize = () => positionRightAndShow();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [subscriptions]);

  return (
    <div
      ref={rootRef}
      className={cn('HowItWorksPicker', className)}
    >
      <Text
        className='top-copy'
        variant='title-xl'
      >
        <span className='italic'>Unlock</span> access to our vast, one-of-a-kind
        closet of luxury accessories.
      </Text>

      <PlanCardList
        className='HowItWorks-PlanCardList'
        data={subscriptions.filter(
          (plan) => !plan.name.match(/premier|privee/i)
        )}
      />
      <Text
        className='HowItWorksPicker-plus-tax'
        variant='text-s'
      >
        *Plus tax
      </Text>

      <PriveeAddOn
        className='HowItWorksPicker-priveeAddOn'
        href='/reserve'
      />

      <div className='HowItWorksPicker-wantMore'>
        <div className='HowItWorksPicker-wantMore-inner'>
          <Text
            className='HowItWorksPicker-wantMore-title'
            variant='title-xs'
            uppercase
          >
            Want more? add premier!
          </Text>
          <Text
            className='HowItWorksPicker-wantMore-text'
            variant='text-m'
          >
            Add Premier to any membership for $49/month and unlock an extra
            piece from our Premier closet — which includes jewelry up to $1,000
            and select designer bags.
          </Text>
        </div>
      </div>
    </div>
  );
}

export default HowItWorksPicker;
